export interface LikeInputApiModel{
    resource_type: string,
    resource_id: number,
    payload?: string,
    type?: string;
}